<template>
  <div class="search-bar__date">
    <div class="alternative">
      <v-date-picker
        ref="popover"
        v-model="dateSelected"
        :popover-direction="calendarDirection"
        :date-picker-show-caps="false"
        :date-picker-show-day-popover="false"
        :pane-width="290"
        :tint-color="'#7f1a54'"
        :max-date="maxDate"
        :min-date="limitData"
        mode="single"
        title
        name="dateFilterSingle"
        show-caps
        expanded
      >
        <md-input-container
          id="datePickerSingleSelect"
          slot-scope="{ inputValue, updateValue, props }"
        >
          <md-input
            id="dateFilterSingle"
            ref="dateFilterSingle"
            :readonly="false"
            type="text"
            :value="inputValue"
            expanded
            @change.native="updateValue($event.target.value)"
          />
          <md-icon :md-src="'/static/images/icon-calendar-alternative.svg'">
            date_range
          </md-icon>
        </md-input-container>
      </v-date-picker>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    calendarDirection: {
      type: String,
      default: 'bottom'
    },
    maxDate: {
      type: Date,
      default: () => new Date()
    },
    limitData: Date
  },
  data: () => {
    return {
      dateSelected: ''
    }
  },
  watch: {
    dateSelected: function (newVal) {
      this.$emit('update:dateSelected', newVal)
    }
  }
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';


</style>
